import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const beneficios = ['Reconocida internacionalmente', 'Sin vencimiento', 'Sin cuotas anuales', 'Válida para bucear en todo el mundo'];
export function CertificacionPadi() {
  return <section className="py-28 sm:py-36 px-6 bg-brand-background relative overflow-hidden" data-id="element-55">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-56">
        {/* Title + subtitle */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-2xl mx-auto" data-id="element-57">
          <h3 className="text-brand-primary font-heading font-black text-4xl sm:text-5xl md:text-6xl uppercase tracking-tight leading-[1.05] mb-6" data-id="element-58">
            Tu certificación internacional PADI
          </h3>
          <p className="text-white/90 text-xl sm:text-2xl font-light leading-relaxed" data-id="element-59">
            Al completar tu entrenamiento recibirás tu certificación Open Water
            Diver de PADI, reconocida en todo el mundo.
          </p>
        </motion.div>

        {/* Featured PADI card photo — the protagonist */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="mt-14 sm:mt-16 mx-auto max-w-lg relative rounded-3xl overflow-hidden aspect-[4/5] shadow-[0_24px_70px_-25px_rgba(0,0,0,0.7)] bg-brand-dark" data-id="element-60">
          <img src="https://cdn.magicpatterns.com/uploads/fYbV7ZLfdNPWto7iJ3hNi6/padi_ceretificacion.jpg" alt="Tarjeta de certificación PADI Open Water Diver sostenida en la mano" className="w-full h-full object-cover object-center" data-id="element-61" />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-background/50 via-transparent to-transparent" data-id="element-62"></div>
        </motion.div>

        {/* Four short benefits */}
        <motion.ul initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.08
          }
        }
      }} className="mt-14 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-63">
          {beneficios.map((item, i) => <motion.li key={i} variants={{
          hidden: {
            opacity: 0,
            y: 12
          },
          visible: {
            opacity: 1,
            y: 0
          }
        }} className="flex items-center gap-3 rounded-2xl border border-brand-primary/20 bg-brand-primary/5 backdrop-blur-sm px-5 py-4 text-white text-base sm:text-lg font-light" data-id="element-64">
              <span className="w-7 h-7 rounded-full bg-brand-primary/15 border border-brand-primary/40 flex items-center justify-center shrink-0" data-id="element-65">
                <Check size={16} className="text-brand-primary" strokeWidth={3} data-id="element-66" />
              </span>
              {item}
            </motion.li>)}
        </motion.ul>

        {/* Short closing paragraph */}
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} className="text-center text-white/80 text-lg sm:text-xl font-light leading-relaxed max-w-2xl mx-auto mt-14" data-id="element-67">
          Tu certificación te permitirá bucear en miles de centros de buceo
          alrededor del planeta y será tu puerta de entrada a nuevas
          experiencias submarinas.
        </motion.p>
      </div>
    </section>;
}